import { createContext } from 'react';
export var TableContext = createContext({
  displayMode: 'auto'
});
TableContext.displayName = 'TableContext';